<script setup>
// ============================================================================
// BonBoZ: trang Thống kê > THẺ HỘI THOẠI — dựng theo đúng bố cục Pancake.
//
// BỐ CỤC:
//   1. Top 5 thẻ đang được gắn nhiều nhất — thanh ngang, "N lần" bên phải
//   2. Tỉ lệ các thẻ đang được gắn        — vòng tròn + chú giải, chữ giữa là
//      "Tổng / N / lượt gắn thẻ"
//   3. Thống kê chi tiết thẻ hội thoại    — bảng xoay ngang, tab [Thống kê chi
//      tiết] [Thống kê ngày hôm nay] + ô tìm kiếm
//
// "THẺ ĐANG ĐƯỢC GẮN = SỐ LẦN GẮN − SỐ LẦN GỠ", đúng công thức Pancake in ngay
// dưới tiêu đề. Vế thứ hai KHÔNG có sẵn trong Chatwoot: `taggings` xoá dòng khi
// gỡ thẻ, và dòng hoạt động "X thêm nhãn Y" trong khung chat đã bị chính đội
// này tắt. Nên trang đọc từ một sổ cái riêng — xem migration
// `20260826000004_create_bonboz_su_kien_the.rb`.
//
// MỘT MẪU SỐ DUY NHẤT cho mọi phần trăm: `tong_gan` của máy chủ, tổng lượt gắn
// ròng của những thẻ còn dương. Vòng tròn buộc phải cộng về 100%, mà bảng lại
// tính phần trăm trên nền khác thì hai chỗ cùng nói "tỉ lệ" ra hai con số khác
// nhau cho cùng một thẻ — người đọc sẽ tin ít nhất một chỗ là sai.
// ============================================================================
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import HieuSuatAPI from 'dashboard/api/bonboz/hieuSuat';
import { useAlert } from 'dashboard/composables';
import { useSelectedPages } from 'dashboard/composables/useSelectedPages';
import { mauCss } from 'dashboard/helper/mauBieuDo';
import BieuDoTron from './BieuDoTron.vue';
import BangThe from './BangThe.vue';
import SectionCard from './SectionCard.vue';
import ReportHeader from '../components/ReportHeader.vue';
import OverviewReportFilters from '../components/OverviewReportFilters.vue';
import PhamVi from './PhamVi.vue';

const { t } = useI18n();
// Moi con so tren trang nay chi duoc dem tren nhung trang dang chon o bang
// dieu khien.
const { selectedInboxIds } = useSelectedPages();

const dangTai = ref(true);
const dangTaiBang = ref(false);
const khoang = ref(null);
const gom = ref('ngay');

// Hai khối trên đầu luôn đọc từ lượt gọi theo NGÀY — chúng nói về khoảng ngày
// đã chọn, không đổi theo tab của bảng.
const soLieu = ref(null);
const soLieuGio = ref(null);

const goi = kieu =>
  HieuSuatAPI.the({
    since: khoang.value.from,
    until: khoang.value.to,
    inboxIds: selectedInboxIds.value,
    gom: kieu,
  }).then(r => r.data);

const taiGio = async () => {
  if (soLieuGio.value || !khoang.value) return;
  dangTaiBang.value = true;
  try {
    soLieuGio.value = await goi('gio');
  } catch {
    soLieuGio.value = null;
    gom.value = 'ngay';
    useAlert(t('BONBOZ.THE_TK.LOI_TAI'));
  } finally {
    dangTaiBang.value = false;
  }
};

const tai = async () => {
  if (!khoang.value) return;
  dangTai.value = true;
  try {
    soLieu.value = await goi('ngay');
    // Số của kỳ cũ không còn đúng sau khi đổi ngày hay đổi trang.
    soLieuGio.value = null;
    if (gom.value === 'gio') await taiGio();
  } catch {
    soLieu.value = null;
    useAlert(t('BONBOZ.THE_TK.LOI_TAI'));
  } finally {
    dangTai.value = false;
  }
};

const doiGom = async kieu => {
  gom.value = kieu;
  if (kieu === 'gio') await taiGio();
};

const doiBoLoc = ({ from, to }) => {
  if (!from || !to) return;
  khoang.value = { from, to };
  tai();
};

// Lua chon trang nam trong `ui_settings` cua nguoi dung, tai ve SAU khi trang
// da mount — lan tai dau tien co the chay khi mang con rong (= tat ca).
watch(selectedInboxIds, tai);

// ------------------------------------------------------------- hai khối đầu
const the = computed(() => soLieu.value?.the || []);
const tongGan = computed(() => soLieu.value?.tong_gan || 0);

// Chỉ thẻ CÒN DƯƠNG mới lên biểu đồ, đúng như Pancake ghi trong phụ đề: thẻ đã
// bị gỡ hết (tổng ≤ 0) không phải "đang được gắn 0%", nó không còn trên bàn.
const the_duong = computed(() => the.value.filter(d => d.tong > 0));
const topNhat = computed(() => the_duong.value.slice(0, 5));
const caoNhat = computed(() => Math.max(1, ...topNhat.value.map(d => d.tong)));

// `mauCss` đọc biến CSS ra chuỗi `rgb(...)`: canvas KHÔNG hiểu `var(--x)`.
// Thẻ nào người dùng chưa đặt màu thì rơi về màu chủ đạo.
const miengTron = computed(() =>
  the_duong.value.map(d => ({
    tag: d.ten,
    so: d.tong,
    nen: d.mau || mauCss('--bonboz-mo'),
  }))
);

const phanTram = d =>
  tongGan.value ? Math.round((d.tong / tongGan.value) * 1000) / 10 : 0;

// ------------------------------------------------------------------- bảng
const nguonBang = computed(() =>
  gom.value === 'gio' ? soLieuGio.value : soLieu.value
);
</script>

<template>
  <ReportHeader
    :header-title="$t('BONBOZ.THE_TK.TIEU_DE')"
    :header-description="$t('BONBOZ.THE_TK.MO_TA')"
  />

  <div class="flex flex-col w-full gap-4 mx-auto max-w-6xl">
    <OverviewReportFilters :disabled="dangTai" @filter-change="doiBoLoc" />

    <PhamVi />

    <div class="grid gap-4 lg:grid-cols-2 lg:items-start">
      <!-- ============ 1. TOP 5 THẺ ============ -->
      <SectionCard
        :title="$t('BONBOZ.THE_TK.TOP_THE')"
        :description="$t('BONBOZ.THE_TK.CONG_THUC')"
      >
        <div
          v-if="dangTai"
          class="h-56 rounded-lg bg-n-alpha-2 animate-pulse"
        />
        <p
          v-else-if="!topNhat.length"
          class="m-0 py-16 text-sm text-center text-n-slate-11"
        >
          {{ $t('BONBOZ.THE_TK.CHUA_CO') }}
        </p>
        <ul v-else class="flex flex-col gap-4 p-0 m-0 list-none">
          <li v-for="d in topNhat" :key="d.ten" class="flex items-center gap-2">
            <span
              class="block i-lucide-tag size-4 shrink-0"
              :style="{ color: d.mau || 'rgb(var(--bonboz-mo))' }"
              aria-hidden="true"
            />
            <span class="w-24 text-sm truncate shrink-0 text-n-slate-12">
              {{ d.ten }}
            </span>
            <span class="flex items-center flex-1 gap-2 min-w-0">
              <span
                class="h-7 rounded bg-[rgb(var(--bonboz-mo)/0.18)]"
                :style="{ width: `${Math.max(2, (d.tong / caoNhat) * 100)}%` }"
              />
              <span
                class="text-xs font-medium whitespace-nowrap tabular-nums text-n-slate-11"
              >
                {{ $t('BONBOZ.THE_TK.N_LAN', { n: d.tong }) }}
              </span>
            </span>
          </li>
        </ul>
      </SectionCard>

      <!-- ============ 2. TỈ LỆ CÁC THẺ ============ -->
      <SectionCard
        :title="$t('BONBOZ.THE_TK.TI_LE')"
        :description="$t('BONBOZ.THE_TK.TI_LE_MO_TA')"
      >
        <div
          v-if="dangTai"
          class="h-56 rounded-lg bg-n-alpha-2 animate-pulse"
        />
        <p
          v-else-if="!the_duong.length"
          class="m-0 py-16 text-sm text-center text-n-slate-11"
        >
          {{ $t('BONBOZ.THE_TK.CHUA_CO') }}
        </p>
        <div v-else class="flex flex-wrap items-center gap-4">
          <div class="relative size-44 shrink-0">
            <div class="absolute inset-0">
              <BieuDoTron :dong="miengTron" />
            </div>
            <!-- Chữ giữa là HTML ĐÈ lên canvas — dịch và style dễ hơn plugin
                 vẽ chữ của chart.js nhiều. -->
            <div
              class="absolute inset-0 grid px-10 text-center pointer-events-none place-content-center"
            >
              <span class="text-xs text-n-slate-11">
                {{ $t('BONBOZ.TRANG_TK.COT_TONG') }}
              </span>
              <span
                class="text-3xl font-semibold leading-tight tabular-nums text-n-slate-12"
              >
                {{ tongGan }}
              </span>
              <span class="text-xs leading-tight text-n-slate-11">
                {{ $t('BONBOZ.THE_TK.LUOT_GAN') }}
              </span>
            </div>
          </div>

          <ul class="flex flex-col flex-1 gap-2.5 p-0 m-0 list-none min-w-44">
            <li
              v-for="d in the_duong"
              :key="d.ten"
              class="flex items-center gap-2"
            >
              <span
                class="block i-lucide-tag size-4 shrink-0"
                :style="{ color: d.mau || 'rgb(var(--bonboz-mo))' }"
                aria-hidden="true"
              />
              <span class="flex-1 text-sm truncate text-n-slate-12">
                {{ d.ten }}
              </span>
              <span class="text-sm tabular-nums shrink-0 text-n-slate-11">
                {{ phanTram(d) }}%
              </span>
            </li>
          </ul>
        </div>
      </SectionCard>
    </div>

    <!-- ============ 3. BẢNG CHI TIẾT ============ -->
    <BangThe
      :the="nguonBang?.the || []"
      :moc="nguonBang?.moc || []"
      :gom="gom"
      :dang-tai="dangTai || dangTaiBang"
      @doi-gom="doiGom"
    />
  </div>
</template>
